import { render } from "./_sql_table.vue?vue&type=template&id=52d37b82&scoped=true"
import script from "./_sql_table.vue?vue&type=script&lang=js"
export * from "./_sql_table.vue?vue&type=script&lang=js"

import "./_sql_table.vue?vue&type=style&index=0&id=52d37b82&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52d37b82"]])

export default __exports__